"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primitiveAttrFormatter = primitiveAttrFormatter;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const isValidPrimitive_js_1 = require("../../../utils/validation/isValidPrimitive.js");
function* primitiveAttrFormatter(attribute, rawValue, { format = true, transform = true, valuePath = [] } = {}) {
    if (!(0, isValidPrimitive_js_1.isValidPrimitive)(attribute, rawValue)) {
        const { type } = attribute;
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidAttribute', {
            message: `Invalid attribute detected while formatting${path !== undefined ? `: '${path}'` : ''}. Should be a ${type}.`,
            path,
            payload: { received: rawValue, expected: type }
        });
    }
    let transformedValue = undefined;
    if (transform) {
        const transformer = attribute.transform;
        transformedValue = transformer !== undefined ? transformer.format(rawValue) : rawValue;
    }
    else {
        transformedValue = rawValue;
    }
    if (attribute.enum !== undefined && !attribute.enum.includes(transformedValue)) {
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidAttribute', {
            message: `Invalid attribute detected while formatting${path !== undefined ? `: '${path}'` : ''}. Should be one of: ${attribute.enum.map(String).join(', ')}.`,
            path,
            payload: { received: transformedValue, expected: attribute.enum }
        });
    }
    if (transform) {
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    const formattedValue = transformedValue;
    return formattedValue;
}
